// (function() {
//   const DEBUG = true;
//   const log = (...args) => DEBUG && console.log('[WCL-Carousel]', ...args);
  
//   class TestimonialCarousel {
//     constructor() {
//       this.track = document.getElementById('testimonialTrack');
//       this.progressBar = document.getElementById('progressBar');
//       this.items = [];
//       this.currentIndex = 0;
//       this.itemsPerView = 4;
//       this.totalItems = 0;
//       this.totalPages = 0;
//       this.isAnimating = false;
//       this.autoplayInterval = null;
      
//       this.init();
//     }
    
//     init() {
//       if (!this.track) { log('ERROR: Track not found'); return; }
//       if (!this.progressBar) { log('ERROR: ProgressBar not found'); return; }
      
//       this.items = this.track.querySelectorAll('.attendees-testimonial-item');
//       this.totalItems = this.items.length;
      
//       //log('Initialized with', this.totalItems, 'items');
//       if (this.totalItems === 0) return;
      
//       this.calculateItemsPerView();
//       this.createProgressDots();
//       this.bindEvents();
//       this.startAutoplay();
//       this.updateCarousel();
      
//       //log('Carousel ready - Items per view:', this.itemsPerView, 'Total pages:', this.totalPages);
//     }
    
//     calculateItemsPerView() {
//       const width = window.innerWidth;
//       if (width < 576) this.itemsPerView = 1;
//       else if (width < 768) this.itemsPerView = 2;
//       else if (width < 1024) this.itemsPerView = 3;
//       else this.itemsPerView = 4;
//       this.totalPages = Math.ceil(this.totalItems / this.itemsPerView);
//      // log('Calculated - Width:', width, 'Items per view:', this.itemsPerView, 'Pages:', this.totalPages);
//     }
    
//     createProgressDots() {
//       const self = this;
//       this.progressBar.innerHTML = '';
      
//       for (let i = 0; i < this.totalPages; i++) {
//         const dot = document.createElement('button');
//         dot.className = 'progress-dot' + (i === 0 ? ' active' : '');
//         dot.setAttribute('type', 'button');
//         dot.dataset.page = i;
        
//         (function(pageIndex) {
//           dot.onclick = function(e) {
//             e.preventDefault();
//             //log('Dot clicked - Page:', pageIndex);
//             self.goToPage(pageIndex);
//           };
//         })(i);
        
//         this.progressBar.appendChild(dot);
//       }
//       //log('Created', this.totalPages, 'dots');
//     }
    
//     updateCarousel() {
//       if (!this.items[0]) return;
      
//       const itemWidth = this.items[0].getBoundingClientRect().width + 19;
//       const offset = this.currentIndex * itemWidth;
//       this.track.style.transform = 'translateX(-' + offset + 'px)';
      
//       const dots = this.progressBar.querySelectorAll('.progress-dot');
//       const currentPage = Math.floor(this.currentIndex / this.itemsPerView);
//       dots.forEach(function(dot, i) {
//         if (i === currentPage) {
//           dot.classList.add('active');
//         } else {
//           dot.classList.remove('active');
//         }
//       });
      
//       //log('Updated - Index:', this.currentIndex, 'Offset:', offset + 'px');
//     }
    
//     goToPage(page) {
//       //log('goToPage called - Page:', page, 'isAnimating:', this.isAnimating);
//       if (this.isAnimating) return;
      
//       this.isAnimating = true;
//       this.currentIndex = page * this.itemsPerView;
      
//       if (this.currentIndex >= this.totalItems) {
//         this.currentIndex = 0;
//       }
      
//       //log('Going to page:', page, 'New index:', this.currentIndex);
//       this.updateCarousel();
//       this.resetAutoplay();
      
//       const self = this;
//       setTimeout(function() { 
//         self.isAnimating = false; 
//         //log('Animation complete');
//       }, 500);
//     }
    
//     next() {
//       //log('next() called - isAnimating:', this.isAnimating);
//       if (this.isAnimating) return;
      
//       this.isAnimating = true;
//       const currentPage = Math.floor(this.currentIndex / this.itemsPerView);
//       const nextPage = (currentPage + 1) % this.totalPages;
//       this.currentIndex = nextPage * this.itemsPerView;
      
//       //log('Next - From page:', currentPage, 'To page:', nextPage);
//       this.updateCarousel();
      
//       const self = this;
//       setTimeout(function() { 
//         self.isAnimating = false; 
//       }, 500);
//     }
    
//     startAutoplay() {
//       const self = this;
//       this.autoplayInterval = setInterval(function() { 
//         self.next(); 
//       }, 5000);
//       //log('Autoplay started');
//     }
    
//     stopAutoplay() {
//       if (this.autoplayInterval) {
//         clearInterval(this.autoplayInterval);
//         this.autoplayInterval = null;
//         //log('Autoplay stopped');
//       }
//     }
    
//     resetAutoplay() {
//       this.stopAutoplay();
//       this.startAutoplay();
//     }
    
//     bindEvents() {
//       const self = this;
//       let resizeTimeout;
      
//       window.addEventListener('resize', function() {
//         clearTimeout(resizeTimeout);
//         resizeTimeout = setTimeout(function() {
//           //log('Window resized');
//           self.calculateItemsPerView();
//           self.createProgressDots();
//           self.currentIndex = 0;
//           self.updateCarousel();
//         }, 250);
//       });
      
//       this.track.addEventListener('mouseenter', function() { 
//         self.stopAutoplay(); 
//       });
//       this.track.addEventListener('mouseleave', function() { 
//         self.startAutoplay(); 
//       });
      
//       //log('Events bound');

//       // Arrow buttons
// const prevBtn = document.getElementById('attendeesPrev');
// const nextBtn = document.getElementById('attendeesNext');

// if (prevBtn) {
//   prevBtn.addEventListener('click', function() {
//     self.stopAutoplay();
//     const currentPage = Math.floor(self.currentIndex / self.itemsPerView);
//     const prevPage = (currentPage - 1 + self.totalPages) % self.totalPages;
//     self.goToPage(prevPage);
//   });
// }

// if (nextBtn) {
//   nextBtn.addEventListener('click', function() {
//     self.stopAutoplay();
//     self.next();
//   });
// }


//     }
//   }
  
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', function() { 
//       new TestimonialCarousel(); 
//     });
//   } else {
//     new TestimonialCarousel();
//   }
// })();

(function() {
  const DEBUG = true;
  const log = (...args) => DEBUG && console.log('[WCL-Carousel]', ...args);
  
  class TestimonialCarousel {
    constructor() {
      this.track = document.getElementById('testimonialTrack');
      this.progressBar = document.getElementById('progressBar');
      this.items = [];
      this.currentIndex = 0;
      this.itemsPerView = 4;
      this.totalItems = 0;
      this.totalPages = 0;
      this.isAnimating = false;

      // swipe state
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.isSwiping = false;
      this.SWIPE_THRESHOLD = 50; // px

      this.init();
    }
    
    init() {
      if (!this.track) { log('Track not found'); return; }
      if (!this.progressBar) { log('Progress bar not found'); return; }
      
      this.items = this.track.querySelectorAll('.attendees-testimonial-item');
      this.totalItems = this.items.length;
      if (this.totalItems === 0) return;
      
      this.calculateItemsPerView();
      this.createProgressDots();
      this.bindEvents();
      this.updateCarousel();
    }
    
    calculateItemsPerView() {
      const width = window.innerWidth;
      if (width < 576) this.itemsPerView = 1;
      else if (width < 768) this.itemsPerView = 2;
      else if (width < 1024) this.itemsPerView = 3;
      else this.itemsPerView = 4;
      this.totalPages = Math.ceil(this.totalItems / this.itemsPerView);
    }
    
    createProgressDots() {
      const self = this;
      this.progressBar.innerHTML = '';
      
      for (let i = 0; i < this.totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'progress-dot' + (i === 0 ? ' active' : '');
        dot.dataset.page = i;
        
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          self.goToPage(i);
        });
        
        this.progressBar.appendChild(dot);
      }
    }
    
    updateCarousel() {
      if (!this.items[0]) return;
      
      const itemWidth = this.items[0].getBoundingClientRect().width + 19;
      const offset = this.currentIndex * itemWidth;
      this.track.style.transform = 'translateX(-' + offset + 'px)';
      
      const dots = this.progressBar.querySelectorAll('.progress-dot');
      const currentPage = Math.floor(this.currentIndex / this.itemsPerView);
      
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentPage);
      });
    }
    
    goToPage(page) {
      if (this.isAnimating) return;
      
      this.isAnimating = true;
      this.currentIndex = page * this.itemsPerView;

      if (this.currentIndex >= this.totalItems) {
        this.currentIndex = 0;
      }

      this.updateCarousel();
      
      setTimeout(() => { 
        this.isAnimating = false; 
      }, 500);
    }
    
    next() {
      if (this.isAnimating) return;
      
      this.isAnimating = true;
      const currentPage = Math.floor(this.currentIndex / this.itemsPerView);
      const nextPage = (currentPage + 1) % this.totalPages;
      this.currentIndex = nextPage * this.itemsPerView;
      
      this.updateCarousel();
      
      setTimeout(() => { 
        this.isAnimating = false; 
      }, 500);
    }

    prev() {
      if (this.isAnimating) return;

      this.isAnimating = true;
      const currentPage = Math.floor(this.currentIndex / this.itemsPerView);
      const prevPage = (currentPage - 1 + this.totalPages) % this.totalPages;
      this.currentIndex = prevPage * this.itemsPerView;

      this.updateCarousel();

      setTimeout(() => {
        this.isAnimating = false;
      }, 500);
    }
    
    bindEvents() {
      const self = this;
      let resizeTimeout;
      
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          self.calculateItemsPerView();
          self.createProgressDots();
          self.currentIndex = 0;
          self.updateCarousel();
        }, 250);
      });

      // Arrow buttons
      const prevBtn = document.getElementById('attendeesPrev');
      const nextBtn = document.getElementById('attendeesNext');

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          self.prev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          self.next();
        });
      }

      // Swipe events
      this.track.addEventListener('touchstart', function(e) {
        if (!e.touches || e.touches.length === 0) return;
        const touch = e.touches[0];
        self.touchStartX = touch.clientX;
        self.touchStartY = touch.clientY;
        self.touchEndX = touch.clientX;
        self.isSwiping = false;
      }, { passive: true });

      this.track.addEventListener('touchmove', function(e) {
        if (!e.touches || e.touches.length === 0) return;
        const touch = e.touches[0];
        const dx = touch.clientX - self.touchStartX;
        const dy = touch.clientY - self.touchStartY;

        // Only treat as swipe if mostly horizontal
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          self.isSwiping = true;
          // Optional: prevent horizontal scrolling interference
          e.preventDefault();
        }

        self.touchEndX = touch.clientX;
      }, { passive: false });

      this.track.addEventListener('touchend', function() {
        if (!self.isSwiping) return;

        const dx = self.touchEndX - self.touchStartX;

        if (Math.abs(dx) >= self.SWIPE_THRESHOLD) {
          if (dx < 0) {
            // swipe left → next
            self.next();
          } else {
            // swipe right → prev
            self.prev();
          }
        }

        self.isSwiping = false;
        self.touchStartX = 0;
        self.touchEndX = 0;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { 
      new TestimonialCarousel(); 
    });
  } else {
    new TestimonialCarousel();
  }
})();
